import React from 'react';
import styled from 'styled-components';
import { ArrowDownIcon, ArrowUpIcon } from '@radix-ui/react-icons';

import type { OrderBy } from './use-order-by';

type SortableHeaderCellProps = React.ThHTMLAttributes<HTMLTableCellElement> & {
  sortKey: string;
  orderBy: OrderBy;
  onOrder: (key: string) => void;
};

export const SortableHeaderCell: React.FC<SortableHeaderCellProps> = ({
  sortKey,
  orderBy,
  onOrder,
  children,
  ...props
}) => (
  <HeaderCell onClick={() => onOrder(sortKey)} {...props}>
    {children}
    {orderBy?.key === sortKey &&
      (orderBy.direction === 'asc' ? <ArrowUpIcon /> : <ArrowDownIcon />)}
  </HeaderCell>
);

export const HeaderCell = styled.th`
  position: relative;
  user-select: none;
  vertical-align: middle;

  &:hover {
    cursor: pointer;
    color: var(--color-grayscale-white);
  }

  svg {
    position: absolute;
    transform: translate(4px, 1px);
    color: var(--color-primary-crayola);
  }
`;
